import { queryOptions } from '@tanstack/react-query';
import { apiInstance } from '../../../../api/api_Instance';
export const map_api = {
    getContacts: () => {
        return queryOptions({
            queryKey: ['map_contacts'],
            queryFn: () => apiInstance.get('/api/contacts'),
            select: data => {
                return convertToGeoJSON(data.data);
            },
        });
    },
};

function convertToGeoJSON(data) {
    // Функция для распределения близких точек
    const distributeClosePoints = (contacts) => {
        const groups = new Map();
        const processedContacts = [];
        const RADIUS = 0.000045;

        // Группируем контакты по близким координатам
        contacts.forEach(contact => {
            if (!contact.coordinates) return;

            const [lng, lat] = contact.coordinates;
            // Округляем координаты до 4 знаков для группировки
            const groupKey = `${lng.toFixed(4)},${lat.toFixed(4)}`;

            if (!groups.has(groupKey)) {
                groups.set(groupKey, []);
            }
            groups.get(groupKey).push(contact);
        });

        // Распределяем точки в группах
        groups.forEach((groupContacts, groupKey) => {
            const [centerLng, centerLat] = groupKey.split(',').map(Number);

            if (groupContacts.length === 1) {
                processedContacts.push(groupContacts[0]);
            } else {
                // Распределяем точки по кругу
                groupContacts.forEach((contact, index) => {
                    const angle = (index / groupContacts.length) * Math.PI * 2;
                    const newLng = centerLng + Math.cos(angle) * RADIUS;
                    const newLat = centerLat + Math.sin(angle) * RADIUS;

                    processedContacts.push({
                        ...contact,
                        coordinates: [newLng, newLat],
                    });
                });
            }
        });

        return processedContacts;
    };

    const distributedData = distributeClosePoints(data);

    return {
        type: 'FeatureCollection',
        features: distributedData
            .map(item => {
                const balloonContent = `
        <strong>${item.name || item.legal_entity || ''}</strong><br/>
        ${item.legal_entity ? `<div>Юр. лицо: ${item.legal_entity}</div>` : ''}
        ${item.address ? `<div>Адрес: ${item.address}</div>` : ''}
        ${item.phone ? `<div>Телефон: ${item.phone}</div>` : ''}
        ${item.website ? `<div>Сайт: ${item.website}</div>` : ''}
        ${item.email ? `<div>Email: ${item.email}</div>` : ''}
      `;
                return {
                    type: 'Feature',
                    id: item.id,
                    geometry: {
                        type: 'Point',
                        coordinates: item.coordinates || [0, 0],
                    },
                    options: {
                        iconImageHref: item.contact_type === "dealer" ? '/images/svg/diller.svg' : '/images/svg/warehouses.svg',
                        // iconLayout: 'default#imageWithContent',
                    },
                    properties: {
                        balloonContent: balloonContent,
                        data: {
                            contact_type: item.contact_type || 'unknown',
                            address: item.address,
                            phone: item.phone,
                            website: item.website,
                            email: item.email,
                        },
                        clusterCaption: item.legal_entity || 'Неизвестное название',
                        hintContent: item.legal_entity || 'Подсказка',
                    },
                };
            })
            .filter(Boolean),
    };
}